import { getAppConfig } from '../..';
export function getB2BPolicyInfo() {
    // can't use useConfig hook here because we aren't in a component
    const configuration = getAppConfig();
    return {
        authority: configuration.REACT_APP_MSAL_AAD_AUTHORITY,
    };
}
